export default __webpack_public_path__ + "media/src/assets/images/csv-cdbaf8dd1bbc1198ffd687f83fd5bcd6.png";